import { createSlice } from "@reduxjs/toolkit";

const gptSlice = createSlice({
  name: "gpt",
  initialState: {
    showMainContainer: false,
    gptmovie: null,
    movieResults: null,
    movieNames: null,
    loading: false,
  },
  reducers: {
    toggleShow: (state, action) => {
      state.showMainContainer = !state.showMainContainer;
    },
    addGptmovie: (state, action) => {
      const { movieNames, movieResults } = action.payload;
      state.movieNames = movieNames;
      state.movieResults = movieResults;
    },
    removeGptMovie: (state, action) => {
      state.movieNames = null;
      state.movieResults = null;
    },
    changeLoading: (state, action) => {
      state.loading = !state.loading;
    },
  },
});
export const { toggleShow, addGptmovie, removeGptMovie, changeLoading } =
  gptSlice.actions;
export default gptSlice.reducer;
